import GalleryCard from "./gallery-card";

export { GalleryCard };
